import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import SyncData from 'modules/payroll_integrations_a3innuva/components/Incidence/SyncData'
import type {
  DiffFields,
  Sync,
} from 'modules/payroll_integrations_a3innuva/lib/IncidenceSync/store'
import fieldTranslations from 'modules/payroll_integrations_a3innuva/lib/fieldTranslations'

const Available = ({
  sync,
  onSync,
  syncing,
}: {
  sync: Sync
  onSync: () => void
  syncing: boolean
}) => {
  const diffFields = sync.diff_fields as DiffFields
  const diffFieldNames = Object.keys(diffFields)
  // FIXME: Intl.ListFormat type is not included in current ts lib
  // We can use it after using es2021 or later
  // https://factorialteam.slack.com/archives/C02J32SSYJE/p1672749115032319
  //
  // const listFormat = new Intl.ListFormat(i18n.locale)
  // const translatedDiffFieldNames = listFormat.format(
  //   diffFieldNames.map((fieldName) => fieldTranslations.t(fieldName))
  // )
  const translatedDiffFieldNames = diffFieldNames
    .map((fieldName) => fieldTranslations.t(fieldName))
    .join(', ')

  return (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.a3innuva.name.available.title')}
      </Text.Header2>
      <Box>
        {i18n.tp('payroll_integrations.incidences.a3innuva.name.available.message', {
          fieldNames: translatedDiffFieldNames,
          count: diffFieldNames.length,
        })}
      </Box>
      <SyncData fields={diffFields} onSync={onSync} syncing={syncing} />
    </>
  )
}

export default Available
